export default {
    accelerate: {
        enabled: true,
    },
    active_deals_my_wallet: {
        enabled: true,
        variables: {
            contact_email: true,
            contact_phone: false,
            contact_sms: false,
            event_bus_contact_email: true,
        },
    },
    global_kbb_branded_wallet: {
        enabled: true,
        variables: {
            kbb_logo_trade_in: true,
        },
    },
    ico: {
        enabled: true,
    },
    my_wallet: {
        enabled: true,
        variables: {
            enable_deals: true,
            hide_info_icons: true,
            hide_payment_toggle: true,
            show_articles: false,
            show_ico: false,
        },
    },
    my_wallet_enhanced_dashboard: {
        enabled: true,
    },
    my_wallet_myatc: {
        enabled: false,
    },
    native_sdp: {
        enabled: false,
    },
    nds_calc: {
        enabled: true,
        variables: {
            trade_in_link: true,
            kbb_text_trade_mark: true,
        },
    },
    retail_engine: {
        enabled: true,
    },
    wallet_central_modal_panel: {
        enabled: true,
    },
    wallet_email_sync: {
        enabled: true,
    },
    wallet_payment_option: {
        enabled: false,
    },
    wallet_sync: {
        enabled: true,
        variables: {
            id_sync: true,
            manual_id_sync: true,
        },
    },
    enable_ecom_cta_in_lease_tab: {
        enabled: true,
    },
    uds_redesign_rollout: {
        enabled: false,
    },
};
